import { render, staticRenderFns } from "./forget-pwd.vue?vue&type=template&id=61bda468&scoped=true"
import script from "./forget-pwd.vue?vue&type=script&lang=js"
export * from "./forget-pwd.vue?vue&type=script&lang=js"
import style0 from "./forget-pwd.vue?vue&type=style&index=0&id=61bda468&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bda468",
  null
  
)

export default component.exports